import PUBLICO from '@/constants/ba/dadosEstado/portal/publico'
import GERAL from '@/constants/ba/dadosEstado/geral'
import ANALISE from '@/constants/ba/dadosEstado/analise'
import FINANCEIRO from '@/constants/ba/dadosEstado/financeiro'

export default {
  ...GERAL,
  PUBLICO,
  ANALISE,
  FINANCEIRO
}



// WEBPACK FOOTER //
// ./src/constants/ba/dadosEstado/index.js